import { getPageRoute } from "../../helpers/navigation";
import {Page} from "../../helpers/content";

export const getLastPagePath = (chapterId: string, subchapterId: string, pages: Page[]) => {
  const lastPageNumber = pages.length;
  return getPageRoute(chapterId, subchapterId, lastPageNumber);
};
